document.querySelectorAll('.facets__item').forEach(item => {
  item.setAttribute('open', ''); // abre todos los filtros
});
document.addEventListener('DOMContentLoaded', () => {
  const allFilters = document.querySelectorAll('.facets__disclosure');

  allFilters.forEach(filter => {
    filter.setAttribute('open', '');
    const summary = filter.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    const display = filter.querySelector('.facets__display');
    if (display) display.style.display = 'block';
  });
});
